const getReadOnlyValue = (readOnlyIndicator, data) => {
    const configuredField = readOnlyIndicator?.field;
    const configuredValue = configuredField ? data?.[configuredField] : undefined;
    if (configuredValue !== undefined && configuredValue !== null) return configuredValue;

    return data?.isReadOnly ?? data?.readOnlyCompany ?? data?.ReadOnlyCompany ?? data?.readOnly;
};

const getAvatarContentKey = (params) => {
    if (!params) return '';

    const data = params.data ?? {};
    const otherFields = params.otherFields ?? params.colDef?.cellRendererParams?.otherFields ?? {};
    const readOnlyIndicator =
        params.readOnlyIndicator ?? params.colDef?.cellRendererParams?.readOnlyIndicator;

    const rowId = data.id ?? data.Id ?? data.ID ?? params.node?.id ?? '';
    const value = params.value ?? '';
    const src = data[otherFields.src] ?? '';
    const placeholder = data[otherFields.placeholder] ?? '';
    const alt = data[otherFields.alt] ?? '';
    const secondaryText = otherFields.secondaryTextKey
        ? (data[otherFields.secondaryTextKey] ?? '')
        : '';
    const readOnly = getReadOnlyValue(readOnlyIndicator, data);
    const showSyncStatus = Boolean(
        params.showSyncStatus ?? params.colDef?.cellRendererParams?.showSyncStatus,
    );
    const syncStatus = showSyncStatus ? (data?.syncStatus ?? data?.SyncStatus ?? '') : '';

    return [rowId, value, src, placeholder, alt, secondaryText, readOnly, syncStatus].join('|');
};

export const isSameAvatarCellContent = (previousParams, nextParams) =>
    getAvatarContentKey(previousParams) === getAvatarContentKey(nextParams);
